import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { pendletonConfig } from "./data";

export default function PendletonPage() {
  return <OregonCityPageTemplate config={pendletonConfig} />;
}